let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("df3Va")).then(() => parcelRequire('lWvfd'));